export default {"src":"/_next/static/media/Keepa Logo Fa.695ce2ff.svg","height":40,"width":100};